import { StyledLink } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

import { useOrgBranding } from "src/hooks/orgConfig/hooks/useOrgBranding";
import useDefaultRoutePath from "src/app/Restricted/useDefaultRoutePath";

const LogoLink = styled(StyledLink)`
  line-height: 0;
`;

const CustomLogo = styled.img`
  ${(props) => props.styles}
`;

const Logo = ({ workspace }) => {
  const defaultRoutePath = useDefaultRoutePath();
  const {
    branding: { logoImage },
  } = useOrgBranding();
  const alt = logoImage?.alt || "logo";

  if (workspace && !workspace.loading && logoImage?.src) {
    return (
      <LogoLink
        bold
        white
        to={defaultRoutePath}
        data-testid="directory-logo-link"
      >
        <CustomLogo {...logoImage} alt={alt} />
      </LogoLink>
    );
  }

  return null;
};

Logo.propTypes = {
  workspace: PropTypes.object,
};

export default Logo;
